import { render } from "./pswLogin.vue?vue&type=template&id=115a7764"
import script from "./pswLogin.vue?vue&type=script&lang=js"
export * from "./pswLogin.vue?vue&type=script&lang=js"

import exportComponent from "F:\\project\\zifeiluntang\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__